import type { FC } from 'react';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { KeywordsVariablesWrapper } from './KeywordsVariables.styled';
import keyword1 from '../../../resources/content/keyword1.png';

interface KeywordsVariablesProps {}

const KeywordsVariables: FC<KeywordsVariablesProps> = () => (
<KeywordsVariablesWrapper>	
   <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">Keywords &amp; Variables</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <figure className="aligncenter size-large">
         <img decoding="async" src={keyword1} alt="" className="reduced-img" />
      </figure>
      
      <p  className="text-align-justify"><strong>Keywords :</strong></p>
      <ul  className="text-align-justify">
         <li>Keywords are reserved words or predefined words that you cannot use as a variable or object name. In addition, they have special meaning for the compiler.</li>
         <li>True, false, and null are not reserved words; however, you cannot use it as identifiers, because it is literals of built-in types.&nbsp;</li>
         <li>Some of the examples include abstract, boolean, break, extend, public, return, etc.</li>
      </ul>

      <p  className="text-align-justify"><strong>Identifier :</strong></p>
      <ul  className="text-align-justify">
         <li>An identifier is a string of alphanumeric characters (a-z , A-Z , 0-9) (i.e. letters &amp; digits) and underscore( _ ) symbol.</li>
         <li>It is a token (in other words, a symbol) that name language entities; for instance, constants, variables, structures, functions, etc.</li>
         <li>Identifier names must be unique and must not contain white spaces.</li>
         <li>The first character should be an alphabet or an underscore.</li>
         <li>You cannot use a keyword as identifiers.</li>
         <li>Identifiers are case-sensitive.</li>
      </ul>

      <p  className="text-align-justify"><strong>Variables :</strong></p>
      <ul  className="text-align-justify">
         <li>&nbsp;A variable is a container that holds the value while the program it executes. The program can change the value stored in a variable during program execution.</li>
         <li>Every variable has a specific type, which determines the following :
            <ul>
               <li>Size of its memory</li>
               <li>The range of values that it can store</li>
               <li>The set of operations that it can apply to the variable.</li>
            </ul>
         </li>
         <li>Examples include (with &amp; without assignment) :
            <ul>
               <li>int total;</li>
               <li>int total = 50;</li>
            </ul>
         </li>
      </ul>
      <br/>
      <EmbedYoutube videoType="video" videoList={["7KixECa4CPM"]} />
   </div>
</KeywordsVariablesWrapper>
);

export default KeywordsVariables;
